import React from "react";

const iconSizeStyles = {
  h1: "!text-[60px]",
  h2: "!text-[48px]",
  h3: "!text-[40px]",
  h4: "!text-[32px]",
  h5: "!text-[24px]",
  h6: "!text-[20px]",
};

const HeaderStyle = ({
  title,
  icon,
  tag: Tag = "h6", // Default tag is "h6"
}) => {
  return (
    <div>
      <div className="header">
        <Tag className="flex items-center gap-1  pb-0.5">
          <span
            className={`material-symbols-outlined font-inherit ${iconSizeStyles[Tag]}`}
          >
            {icon}
          </span>

          {title}
        </Tag>
      </div>
    </div>
  );
};

export default HeaderStyle;
